import { useRef, useState } from "react";
import { Play } from "lucide-react";
import { Reveal, Overline } from "../components/Reveal";
import { PARENT_VIDEO_URL } from "../data/content";

export const ParentStory = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const play = () => {
    if (!ref.current) return;
    ref.current.play();
    setPlaying(true);
  };
  return (
    <section id="parent-story" className="py-24 sm:py-32 scroll-mt-16" data-testid="parent-story-section">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <Reveal>
          <div className="grid lg:grid-cols-[1fr_1.15fr] gap-10 lg:gap-16 items-center">
            {/* Copy */}
            <div>
              <Overline>Featured Parent Story</Overline>
              <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight mt-3 max-w-md">
                Straight from a <span className="text-[#D4AF37]">Zavi parent.</span>
              </h2>
              <p className="mt-5 text-white/70 text-[15px] leading-relaxed max-w-md">
                Four years. One academy. Hear Ahnay's father explain — in his own words — why the Zavi environment has been the right home for his son's growth.
              </p>
              <div className="mt-6 flex flex-wrap gap-2">
                {["Discipline", "Development", "Confidence", "A Brighter Tomorrow"].map((tag) => (
                  <span key={tag} className="text-[10px] uppercase tracking-widest text-[#D4AF37] border border-[#D4AF37]/30 px-2.5 py-1" data-testid={`parent-tag-${tag.toLowerCase().replace(/\s+/g, '-')}`}>{tag}</span>
                ))}
              </div>
            </div>

            {/* Portrait video */}
            <div className="mx-auto w-full max-w-sm sm:max-w-md">
              <div className="relative border border-white/10 bg-black overflow-hidden aspect-[9/16] shadow-[0_20px_60px_rgba(0,0,0,0.6)]">
                <video
                  ref={ref}
                  src={PARENT_VIDEO_URL}
                  poster="/assets/parent-poster.jpg"
                  controls={playing}
                  preload="none"
                  playsInline
                  className="w-full h-full object-cover"
                  data-testid="parent-video"
                />
                {!playing && (
                  <button
                    onClick={play}
                    className="absolute inset-0 flex items-center justify-center bg-black/25 hover:bg-black/15 transition-colors duration-200 group"
                    data-testid="parent-play"
                    aria-label="Play parent testimonial"
                  >
                    <span className="flex items-center justify-center w-20 h-20 sm:w-24 sm:h-24 bg-[#D4AF37] group-hover:bg-[#F3D059] rounded-full shadow-[0_0_40px_rgba(212,175,55,0.55)] transition-colors duration-200">
                      <Play size={30} className="text-black translate-x-0.5" fill="black" />
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
